import axios from "axios";

const API_BASE_URL = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL; // Replace with your Strapi URL

export const createPayPayPayment = async (data: any) => {
  try {
    const response = await axios.post(`${API_BASE_URL}payment/create`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating PayPay payment:", error);
    throw error;
  }
};
